import React = require("react")

export const Pager = (props: { currentPage: number, setPage: (pageNumber: number) => void, pageSize: number, totalResults: number, maxPageLinks?: number, containerSize? : string }) => {
  const { currentPage, setPage, pageSize, totalResults } = props
  const maxPageLinks = props.maxPageLinks || 6
  const lastPage = Math.ceil(totalResults / pageSize)
  if (lastPage <= 1) return <></>

  const pagesBracket = Math.floor(maxPageLinks / 2)
  const active = (page: number) => 1 <= page && page <= lastPage
  const prevPage = currentPage - 1
  const nextPage = currentPage + 1

  let navArray: [number, string, boolean, string][] = []

  if (lastPage <= maxPageLinks) {
    Array.from({ length: lastPage }, (_, i) => i + 1).forEach(i => navArray.push([i, i.toString(), active(i), i == lastPage ? 'last number' : 'number']))
  } else {
    // First link should never be below 1, and never over lastPage - maxPages
    const first = Math.min(Math.max(1, currentPage - pagesBracket), lastPage - maxPageLinks + 1)
    const last = Math.min(lastPage, currentPage + pagesBracket)

    if (first > 1) navArray.push([1, '1', active(1), 'first number'])       // If the first page falls outside the maxPages range, add it explicitly
    if (first > 2) navArray.push([null, ellipses, false, 'ellipsis'])   // If the first link in the pager is 3 or higher, add ellipses

    Array.from({ length: maxPageLinks }, (_, i) => first + i).forEach(i => navArray.push([i, i.toString(), active(i), i == lastPage ? 'last number' : 'number']))

    if (last < lastPage - 1) navArray.push([null, ellipses, false, 'ellipsis']) // Add ellipses if last page in range is more than 1 removed from actual last page
    if (last < lastPage) navArray.push([lastPage, lastPage.toString(), active(lastPage), 'last number']) // Add last page if not in range
  }

  return <div className={`pager container--${props.containerSize ? props.containerSize : 'mg'} align--center`}>
    <button disabled={prevPage == 0 ? true : null} className="pager__prev button button--secondary button--arrow" onClick={(e) => { setPage(prevPage) }}><span className="button__label">Vorige pagina</span></button>
    <span className="pager__status pager__active" aria-hidden="true">{currentPage} / {lastPage}</span>
    <ul className="pager__list">
      {navArray.map(([page, label, active, extraClasses], i) =>
        extraClasses == 'ellipsis' ?
          <li key={'page-' + label + i + extraClasses} className={`pager__item ${extraClasses ? extraClasses : ''}`}><span className="pager__active">{label}</span></li>
          : page != currentPage
            ? <li key={'page-' + label + i + extraClasses} className={`pager__item ${extraClasses ? extraClasses : ''}`}><button className="pager__link" onClick={(e) => { setPage(page) }}>{label}</button></li>
            : <li key={'page-' + label + i} className={`pager__item ${page == currentPage ? 'pager__item--active' : ''} ${extraClasses ? extraClasses : ''}`}><span className="pager__active">{label}</span></li>
      )}
    </ul>
    <button disabled={nextPage > lastPage ? true : null} className="pager__next button button--secondary button--arrow" onClick={(e) => { setPage(nextPage) }}><span className="button__label">Volgende pagina</span></button>
  </div>
}

const ellipses = '\u2026'